var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row w-100 pl-5 justify-content-start",style:({
    //backgroundImage: `url(${require('@/assets/img/page_bg.png')})`,
    paddingRight: '0px',
    margin: '0px',
    padding: '0px !important',
  }),attrs:{"id":"dashboard"}},[_c('div',{staticClass:"container-fluid"},[_c('div',{attrs:{"id":"chart"}},[_c('apexchart',{attrs:{"type":"line","height":"350","options":_vm.chartOptions,"series":_vm.series}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }